/**
 * Validators for global outcome configuration fields
 */
export const globalOutcomeConfigValidators = {
  joy_points: {
    points: {
      required: true,
      validate: (value) => {
        if (!value || value.trim() === "") {
          return "This field is required";
        }
        return false;
      },
    },
    limit: {
      required: true,
      validate: (value) => {
        if (!value || value.trim() === "") {
          return "This field is required";
        }
        return false;
      },
    },
  },
};
